class FilterList {
	constructor() {
		this.groups = [];
		this.saved = filtersJSON ? JSON.parse(filtersJSON) : false;

		this.popup = Dialog.Popup(
			'filter', 
			div(null, [
				htm('h4', null, 'Filters'),
				this.groupsElem = div(),
				this.clearBtn = btn('btn', _('CLEAR ALL'), {
					'click': this.clear.bind(this)
				})
			]),
			'below-end'
		).sticky();
		
		this.button = ge('filter-button');
		onEv(this.button, 'click', () => this.popup.handle(this.button));
		onEv(document, 'filterSelected', () => this.saved = false);
	}
	
	addGroup(title, name, controller) {
		let group = new FilterGroup(this, title, name, controller);
		this.groups.push(group);
		this.groupsElem.appendChild(group.elem);
	}

	clear() {
		this.groups.forEach(g => g.clear());
		document.dispatchEvent(new Event('filterSelected'));
	}

	get toString() {
		let res = '';
		if (this.saved) {
			for (let g in this.saved) {
				res += this.saved[g].split(',').map(s => `&${g}[]=${s}`);
			}
		}
		else {
			for (let g of this.groups) {
				res += g.toString;
			}
		}
		return res;
	}
}
